import { render, staticRenderFns } from "./TransactionsPagination.vue?vue&type=template&id=5ae9d72e"
import script from "./TransactionsPagination.vue?vue&type=script&lang=js"
export * from "./TransactionsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports